import { produce } from 'immer'
import { downloadTransactionsRouteProps } from 'src/navigation/routeProps'
import {
  POST_ORG_EXPENSE_REPORT_DOWNLOAD_FAILURE,
  POST_ORG_EXPENSE_REPORT_DOWNLOAD_INIT,
  POST_ORG_EXPENSE_REPORT_DOWNLOAD_SUCCESS,
  POST_REPORT_TRANSACTIONS_DOWNLOAD_FAILURE,
  POST_REPORT_TRANSACTIONS_DOWNLOAD_INIT,
  POST_REPORT_TRANSACTIONS_DOWNLOAD_SUCCESS,
  PostOrgExpenseReportDownloadActions,
  PostReportTransactionsDownloadActions,
} from 'src/redux/actions/data/reportDownloads.actions'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface DownloadTransactionsState {
  reportDownloadId?: string
  postingReportTransactionsDownload: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: DownloadTransactionsState = {
  postingReportTransactionsDownload: false,
}

export type Actions =
  | PostReportTransactionsDownloadActions
  | PostOrgExpenseReportDownloadActions

const CoreDownloadTransactionsReducer = (
  state = initialState,
  action: Actions,
): DownloadTransactionsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_REPORT_TRANSACTIONS_DOWNLOAD_INIT:
      case POST_ORG_EXPENSE_REPORT_DOWNLOAD_INIT: {
        draft.postingReportTransactionsDownload = true
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }

      case POST_REPORT_TRANSACTIONS_DOWNLOAD_SUCCESS:
      case POST_ORG_EXPENSE_REPORT_DOWNLOAD_SUCCESS: {
        draft.postingReportTransactionsDownload = false
        draft.reportDownloadId = action.payload.reportDownload.id
        return draft
      }

      case POST_REPORT_TRANSACTIONS_DOWNLOAD_FAILURE:
      case POST_ORG_EXPENSE_REPORT_DOWNLOAD_FAILURE: {
        draft.postingReportTransactionsDownload = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const DownloadTransactionsReducer = createFlyoutReducer(
  downloadTransactionsRouteProps,
  initialState,
  CoreDownloadTransactionsReducer,
)

export default DownloadTransactionsReducer
